import { createClient } from '@supabase/supabase-js';

// Supabase configuration
// Note: If you're getting ERR_NAME_NOT_RESOLVED, the project might not exist or URL is incorrect
const supabaseUrl = 'https://pcjpjarhhdefajlrdfav.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBjanBqYXJoaGRlZmFqbHJkZmF2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc1ODU3MzQsImV4cCI6MjA3MzE2MTczNH0.0pxa6WxjqzCwldiZb-t8O5Fouqp7XN-UpSFQni4INt0';

// Alternative: Try with different URL format if the above doesn't work
// const supabaseUrl = 'https://pcjpjarhhdefajlrdfav.supabase.co';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export interface Database {
  public: {
    Tables: {
      users: {
        Row: {
          id: string;
          email: string;
          name: string;
          company: string;
          position: string;
          country: string;
          about: string | null;
          avatar_url: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          email: string;
          name: string;
          company: string;
          position: string;
          country: string;
          about?: string | null;
          avatar_url?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          email?: string;
          name?: string;
          company?: string;
          position?: string;
          country?: string;
          about?: string | null;
          avatar_url?: string | null;
          created_at?: string;
          updated_at?: string;
        };
      };
      connections: {
        Row: {
          id: string;
          requester_id: string;
          recipient_id: string;
          status: 'pending' | 'accepted' | 'rejected';
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          requester_id: string;
          recipient_id: string;
          status?: 'pending' | 'accepted' | 'rejected';
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          requester_id?: string;
          recipient_id?: string;
          status?: 'pending' | 'accepted' | 'rejected';
          created_at?: string;
          updated_at?: string;
        };
      };
      meetings: {
        Row: {
          id: string;
          requester_id: string;
          recipient_id: string;
          meeting_date: string;
          time_slot: string;
          table_number: number;
          subject: string;
          description: string | null;
          location: string | null;
          status: 'pending' | 'confirmed' | 'rejected' | 'cancelled';
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          requester_id: string;
          recipient_id: string;
          meeting_date: string;
          time_slot: string;
          table_number?: number;
          subject: string;
          description?: string | null;
          location?: string | null;
          status?: 'pending' | 'confirmed' | 'rejected' | 'cancelled';
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          requester_id?: string;
          recipient_id?: string;
          meeting_date?: string;
          time_slot?: string;
          table_number?: number;
          subject?: string;
          description?: string | null;
          location?: string | null;
          status?: 'pending' | 'confirmed' | 'rejected' | 'cancelled';
          created_at?: string;
          updated_at?: string;
        };
      };
    };
  };
}